var map = {
	"./layouts/Admin": 64314,
	"./layouts/ThreeDTourEmbed": 5141,
	"./layouts/Truva": 55010,
	"./layouts/VideoEmbed": 33882,
	"components/layouts/Admin": 64314,
	"components/layouts/ThreeDTourEmbed": 5141,
	"components/layouts/Truva": 55010,
	"components/layouts/VideoEmbed": 33882
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75239;